var protobuf = require('./weichatPb/protobuf.js');
var awesomeConfig = require('./weichatPb/proto.js');
import Bus from './bus.js';
var AwesomeRoot = protobuf.Root.fromJSON(awesomeConfig);
const WSBaseReqProto = AwesomeRoot.lookup("protocol.ImReqMessage");
const WSBaseResProto = AwesomeRoot.lookup("protocol.ImResMessage");

let heartbeatInterval = '' // 心跳定时器
var socketTask = null // websocket对象
let ReconnectMaxCount = 5  //最大重连次数
let	ReconnectCount = 0  //客服socket重连次数
let	SocketReconnectTime = 3000  //重连间隔
let isSocketClose = false // 是否关闭socket
let againTimer = null //断线重连定时器
let	customerSocketPingTime = 180000 // 心跳的间隔，当前为 180秒,
let loginAckTimer = null;
let pingAckTimer = null;
let socketUrl = process.env.VUE_APP_WEBSOCKET_URL;


// WebSocket 编码
var WSResEncode = function(payload) {
	// console.log('protobuf编码payload',payload)
	// console.log('protobufjs编码payload',payload)
	let errMsg = WSBaseReqProto.verify(payload);
	errMsg && console.log("buff 解析错误信息：", errMsg);
	// Create a new message
	const wsData = WSBaseReqProto.create(payload);
	// Encode a message to an Uint8Array (browser) or Buffer (node)
	return WSBaseReqProto.encode(wsData).finish();
}
// WebSocket 解码
var WSResDecode = function(buffer, cb) {
	let reader = new FileReader();
    reader.readAsArrayBuffer(buffer);
    reader.onload = () => {
        const buf = new Uint8Array(reader.result);
        const response = WSBaseResProto.decode(buf);
        cb(response);
    };
}


/* 收到的 ACK 消息（表示客户端发送的消息被服务端确认）
	将发出后的消息状态进行修改
 */
const weixincustomerSocketMessageAck = function(ackRes){
//   vm.$store.dispatch('setACKMessage',ackRes);
}
// 监听客服socket关闭
const weixincustomerSocketHandleClose = function(){
	console.log('监听客服socket关闭');
	// vm.$store.dispatch('setCustomerOpen',false);
	//停止发送心跳
	clearInterval(heartbeatInterval)
	if (!isSocketClose) {
		weixincustomerSocketMessageReconecct()
	}
}

// 主动断开客服socket
const weixincustomerSocketClose = function(){
	console.log('主动断开客服')
	// vm.$store.dispatch('setCustomerOpen',false);
	//停止发送心跳
	isSocketClose = true;
	clearInterval(heartbeatInterval)
	socketTask && socketTask.close();
}
// 监听客服socket打开失败
const weixincustomerSocketHandleError = function(){
	console.log('WebSocket连接打开失败，请检查！')
	weixincustomerSocketHandleClose();
	clearPingAckTimer();
	clearLoginAckTimer();
}

/* 收到的 CHAT 消息（表示该消息为聊天消息）
 */
const weixincustomerSocketMessageChat = function(res){
	console.log('weixincustomerSocketMessageChat---收到其他人的消息res',res);
	// vm.$store.dispatch('setPushChatViewList',res);
}
/* 收到的 LOGINOUT 消息（表示登陆异常需要关闭socket并跳转到登录页） 
 * 1.登出socket
 * 2.清空vuex中的socket数据
 * 3.调用 $Logout 方法
 */
const weixincustomerSocketMessageLoginOut = async function(res){
	console.log('登录已过期，请重新登录！')
	weixincustomerSocketClose();
	// vm.$store.dispatch('setClearSocketMessage');
	// vm.$Logout('登录已过期，请重新登录！');
}
/*  收到的 ADDUSER 消息（表示新增群组成员）
 *  加入了新的群聊
 *  chatDestType: 1
	clientMsgId: "0"
	createTime: "1675327827615"
	dest: 2
	destId: "56"
	destUserLoginType: "APP"
	destUserType: "APP_USER"
	fromId: "1"
	fromRoleType: "SYS_USER:DISPATCH_ROLE"
	fromUserLoginType: "PC"
	fromUserType: "SYS_USER"
	groupId: "51"
	id: "511675327827615"
	msgBody: "您加入了新的群聊！"
	msgType: 5
	version: 1
 */
const weixincustomerSocketMessageAddUser = function(res){
	console.log('weixincustomerSocketMessageAddUser---新增群组成员res',res);
	// vm.$store.dispatch('addUserToGroup',res);
}
/**
 * @param {Object} res
 * 同步消息（vip多账号登录）消息需要同步
 * 当两个端同时登录一个账号时需要同步过来信息 
 * 若是当前聊天框的信息 则将消息push到聊天内容中  若是其他聊天框的信息 则更新聊天此聊天的最后一条信息内容及时间以及未读+1（pc vip小蜜蜂用户 同时登录）
 */
const weixincustomerSocketOnlineMessage = function(res){
	// vm.$store.dispatch('setOnlineMessage',res);
}
/* 收到的 NOTIFICATION 消息 
 * tms订单相关消息通知
 * 1.弹出消息窗口
 */
const weixincustomerSocketMessageNotFication = function(res){
	if(res.msgBody){
		res.msgBody = JSON.parse(res.msgBody);
        Bus.$emit('updateOrder')
	}
}
/* 收到的 RECONECCT 消息（表示socket服务更换） 
 * 1.重连socket
 */
const weixincustomerSocketMessageReconecct = function(res){
	console.log('进入断线重连');
	clearInterval(heartbeatInterval);
	if(againTimer){
		clearInterval(againTimer);
		againTimer = null;
	}
	// 连接  重新调用创建websocet方法
	againTimer = setInterval(() => {
		// 超出最大重连次数
		if(ReconnectCount >= ReconnectMaxCount){
			clearInterval(againTimer) //断线重连定时器
			againTimer = null;
		}else{
			ReconnectCount ++;
			uniScoketInit();
			console.log('在重新连接中...')
		}
	}, SocketReconnectTime)
}
/*
	群聊解散
	chatDestType: 1
	clientMsgId: "0"
	createTime: "1673939251495"
	dest: 2
	destId: "56"
	destUserLoginType: "APP"
	destUserType: "APP_USER"
	fromId: "1"
	fromRoleType: "SYS_USER:DISPATCH_ROLE"
	fromUserLoginType: "PC"
	fromUserType: "SYS_USER"
	groupId: "28"
	id: "281673939251492"
	msgBody: "群聊解散！"
	msgType: 9
	version: 1
	
	别人退出群聊
	chatDestType: 1
	clientMsgId: "0"
	createTime: "1675299950902"
	dest: 2
	destId: "56"
	destUserLoginType: "APP"
	destUserType: "APP_USER"
	fromId: "1"
	fromRoleType: "SYS_USER:DISPATCH_ROLE"
	fromUserLoginType: "PC"
	fromUserType: "SYS_USER"
	groupId: "24"
	id: "241675299950899"
	msgBody: "有人退出了群聊！"
	msgType: 9
	version: 1
*/
const weixincustomerSocketGroupOut = function(res){
	// vm.$store.dispatch('setSelectGroup',res);
}
 
/* 客服socket接受消息 
 * 	GREET = 0;  默认
		ACK = 1;  消息确认
		ERROR = 2;  服务器无该消息
		CHAT = 3;  聊天消息
		LOGINOUT = 4;  登陆异常
		ADDUSER = 5;  群组成员变动
		NOTIFICATION = 6;  tms订单相关消息
		RECONECCT = 7;  socket服务变更的重连
 */
const weixincustomerSocketHandleMessage = function(event){
    console.log('event: ', event);
	let { data } = event;
    console.log('data: ', data);
	WSResDecode(data,res=>{
		console.log('socket接收消息解码res -----111----',res)
		let msgType = res.msgType;
		switch(msgType){
			case 1:
				weixincustomerSocketMessageAck(res);
				break;
			case 3:
				// 收到并处理其他用户的消息
				weixincustomerSocketMessageChat(res);
				break;
			case 4:
				// 登出
				weixincustomerSocketMessageLoginOut(res);
				break;
			case 5:
				// 新增群组成员
				weixincustomerSocketMessageAddUser(res);
				break;
			case 6:
				// 收到订单相关信息
				weixincustomerSocketMessageNotFication(res);
				break;
			case 7:
				// socket服务更换，需要重连
				weixincustomerSocketMessageReconecct(res);
				break;
			case 8:
				// FORWARDCHAT  转发消息，同一个账号不同终端登录时 自己发送的消息
				weixincustomerSocketOnlineMessage(res);
				break;
			case 9:
				// 1、群组成员有删除 更新group List
				weixincustomerSocketGroupOut(res);
				break;
			case 11:
				weixincustomerSocketPingAck();
				break;
			case 12:
				weixincustomerSocketLoginAck();
				break;
			case 13:
				weixincustomerSocketRepetitionOpenChannel();
				break;
			default: console.log('switch进入了默认');
		}
	})
};

const weixincustomerSocketRepetitionOpenChannel = function(){
	weixincustomerSocketMessageReconecct();
}

const weixincustomerSocketPingAck = function(){
	clearTimeout(pingAckTimer);
	pingAckTimer = null;
	console.log("ping ack");
};

const weixincustomerSocketLoginAck = function(){
	clearTimeout(loginAckTimer);
	loginAckTimer = null;
	console.log("login ack");
}

// 发送socket消息
const weixincustomerSocketSend = function(payload,callback){
	console.log('payload',payload)
	let buffer = WSResEncode(payload);
	console.log('小程序----发送信息~~~~~',buffer);
	if(socketTask){
		socketTask.send(buffer)
	}else{
		console.log('socket未连接')
	}
}
// 监听客服socket打开
const weixincustomerSocketHandleOpen = function(token){
    console.log('socket打开:------ ',token);
	// vm.$store.dispatch('setCustomerOpen',true);
	againTimer && clearInterval(againTimer) //断线重连定时器
	againTimer = null;
	heartbeatInterval && clearInterval(heartbeatInterval)
	// 发送登录信息
	const payload = {
		"version": 1,
		// "token": "aae9b3c3618319a9bd582feb84e32b8a",
		"token": token,
		"reqType": "LOGIN",
		"chat": {},
		"id": new Date().getTime() + ""
	}
	weixincustomerSocketSend(payload);
	loginAckTimer && clearTimeout(loginAckTimer);
	// loginAckTimer = setTimeout(()=>{
	// 	isLoginPage() && vm.$store.dispatch("weixincustomerSocketMessageReconecct")
	// },5000);
	// 发送心跳
	const pingLoad = {
		"version": 1,
		"token": token,
		"reqType": "PING",
		"chat": {},
		"id": new Date().getTime() + ""
	};
	weixincustomerSocketSend(pingLoad);
	pingAckTimer && clearTimeout(pingAckTimer);
	// pingAckTimer = setTimeout(()=>{
	// 	isLoginPage() && vm.$store.dispatch("weixincustomerSocketMessageReconecct")
	// },5000);
	// 10秒发送一次心跳
	heartbeatInterval = setInterval(() => {
		weixincustomerSocketSend(pingLoad);
		pingAckTimer && clearTimeout(pingAckTimer);
		// pingAckTimer = setTimeout(()=>{
		// 	isLoginPage() && vm.$store.dispatch("weixincustomerSocketMessageReconecct")
		// },5000);
	}, customerSocketPingTime)
	// 清空重连的次数
	ReconnectCount = 0;
	
	// commit('SET_CUSTOMER_IS_OPEN',true);
	// dispatch('msgPushListener');
	// dispatch('setTabBarNewsBadge');
}

const isLoginPage = function(){
	// 获取当前页面路由
	let pages = getCurrentPages();
	let page = pages && pages[pages.length - 1] && pages[pages.length - 1].route;
	let isLoginPage = page ? !['pages/welcome/index','pages/login/index'].includes(page) && (vm.$store.state.user.accessToken || vm.$store.state.vipUser.vipAccessToken) : false ;
	return isLoginPage
}

// 初始化socket
const uniScoketInit = function(token){
	//判断是否有websocet对象，有的话清空
	console.log('打开---微信小程序---socketTask',token);
	if (socketTask) {
		isSocketClose = true;
		socketTask.close();
		clearInterval(heartbeatInterval)
		clearInterval(againTimer)
		socketTask = null;
	}
	socketTask = new WebSocket(socketUrl);

    socketTask.onopen = (() => weixincustomerSocketHandleOpen(token));
    socketTask.onmessage = ((event) => weixincustomerSocketHandleMessage(event));
    socketTask.onclose = ((value) => weixincustomerSocketHandleClose(value));
}

const clearPingAckTimer = function(){
	if(!pingAckTimer) return;
	clearTimeout(pingAckTimer);
	pingAckTimer = null;
};

const clearLoginAckTimer = function(){
	if(!loginAckTimer) return;
	clearTimeout(loginAckTimer);
	loginAckTimer = null;
};

export default {
	uniScoketInit:uniScoketInit,
	weixincustomerSocketClose:weixincustomerSocketClose,
	weixincustomerSocketSend:weixincustomerSocketSend,
}